<mat-button-toggle-group
  class="filter-toggle-group"
  name="tabToggle"
  [multiple]="false">
  <mat-button-toggle
    *ngFor="let stat of primaryStatFilters"
    class="toggle-button"
    routerLinkActive="mat-button-toggle-checked"
    (click)="toggleFilter(stat)">
    <mg-text variant="body-sm-secondary"> {{ stat.title }} · {{ stat.countText }} </mg-text>
  </mat-button-toggle>
</mat-button-toggle-group>

<div class="feed-items">
  <mg-stream-scroller
    *ngIf="contentFilter"
    [filter]="$any(contentFilter)"
    [service]="reportStreamManager"
    rpcStream="streamReports"
    rpcControl="streamReportsControl"
    mgStreamControl="MingaReportFeed"
    [clearOnRestart]="true"
    [bufferAmount]="20">
    <ng-template
      let-item
      let-itemId="itemId"
      mgStreamItem>
      <mg-detailed-moderation-item
        [content]="item"
        [updateStatusFromStream]="globalContent"
        [showMinga]="!!globalContent"
        (openContentCallback)="onOpenContent($event)"
        (openImagesCallback)="onOpenImages($event)"
        [showLongDateFormat]="showLongFormatDateComment">
      </mg-detailed-moderation-item>
    </ng-template>
    <p
      mg-stream-empty
      class="mg-centered mg-minicopy">
      {{ noResultsText }}
    </p>
  </mg-stream-scroller>
</div>
